/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccessRequestPostRequest
 */
export interface AccessRequestPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestPostRequest
     */
    app_external_connection_id: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestPostRequest
     */
    identifier_from_source: string;
    /**
     * Person ID
     * @type {string}
     * @memberof AccessRequestPostRequest
     */
    person_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestPostRequest
     */
    action?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestPostRequest
     */
    target?: string;
    /**
     * 
     * @type {Date}
     * @memberof AccessRequestPostRequest
     */
    valid_until?: Date;
}

/**
 * Check if a given object implements the AccessRequestPostRequest interface.
 */
export function instanceOfAccessRequestPostRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "app_external_connection_id" in value;
    isInstance = isInstance && "identifier_from_source" in value;

    return isInstance;
}

export function AccessRequestPostRequestFromJSON(json: any): AccessRequestPostRequest {
    return AccessRequestPostRequestFromJSONTyped(json, false);
}

export function AccessRequestPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestPostRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'app_external_connection_id': json['app_external_connection_id'],
        'identifier_from_source': json['identifier_from_source'],
        'person_id': !exists(json, 'person_id') ? undefined : json['person_id'],
        'action': !exists(json, 'action') ? undefined : json['action'],
        'target': !exists(json, 'target') ? undefined : json['target'],
        'valid_until': !exists(json, 'valid_until') ? undefined : (new Date(json['valid_until'])),
    };
}

export function AccessRequestPostRequestToJSON(value?: AccessRequestPostRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'app_external_connection_id': value.app_external_connection_id,
        'identifier_from_source': value.identifier_from_source,
        'person_id': value.person_id,
        'action': value.action,
        'target': value.target,
        'valid_until': value.valid_until === undefined ? undefined : (value.valid_until.toISOString()),
    };
}

